import Color from 'color'
import { IStore } from '../../index'

export function getCustomColors(state: IStore): Color[] {
  return state.bookingCalendar.customColors
}

export function getCustomReservationColors(state: IStore): Color[] {
  return state.bookingCalendar.customReservationColors
}
